import axios from "axios";

const api = axios.create({
    baseURL: "https://api.fascistogramme.be/api"
});

export default {
    async sendMessage(message){
        const response = await api.post("/chat",{
            message
        });
        return response.data;
    },

    async getDimensions(id){
        const response = await api.get("/chat/"+id+"/dimensions");
        return response.data;
    },

    async getStats(){
        const response = await api.get("/stat");
        return response.data;
    }
}